import initialState from './initialState';
import {
  ENDPOINTS_CONNECTORS_PANEL_GET_LIST_INIT,
  ENDPOINTS_CONNECTORS_PANEL_GET_LIST_SUCCESS,
  ENDPOINTS_CONNECTORS_PANEL_GET_LIST_FAILURE,
  ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_INIT,
  ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_SUCCESS,
  ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_FAILURE,
  ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_INIT,
  ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_SUCCESS,
  ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_FAILURE,  
  ENDPOINTS_CONNECTORS_PANEL_SET_PERIOD_ID,
  ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_INIT,
  ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_SUCCESS,
  ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_FAILURE,
  ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_INIT,
  ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_SUCCESS,
  ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_FAILURE,
  ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_INIT,
  ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_SUCCESS,
  ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_FAILURE,
  ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_INIT,
  ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_SUCCESS,
  ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_FAILURE,
  ENDPOINTS_CONNECTORS_PANEL_RESET,
} from '../../actions/endpointsConnectorsPanel/types';
import ReducersTooling from '../../../tooling/reducersTooling';

export default function endpointsConnectorsAdmin(state = initialState, action) {
  switch (action.type) {      
    case ENDPOINTS_CONNECTORS_PANEL_GET_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "list");
    case ENDPOINTS_CONNECTORS_PANEL_GET_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "list");
    case ENDPOINTS_CONNECTORS_PANEL_GET_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "list");
    case ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "periodsList");
    case ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "periodsList");
    case ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "periodsList");
    case ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "runConnector");
    case ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "runConnector");
    case ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "runConnector");
    case ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "lastUpdatesList");
    case ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "lastUpdatesList");
    case ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "lastUpdatesList");
    case ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "calculationUnitsFilter");
    case ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "calculationUnitsFilter");
    case ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "calculationUnitsFilter");
    case ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "groupsFilter");
    case ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "groupsFilter");
    case ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "groupsFilter");
    case ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "polynomialsList");
    case ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "polynomialsList");
    case ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "polynomialsList");
    case ENDPOINTS_CONNECTORS_PANEL_RESET:
      return initialState;
    case ENDPOINTS_CONNECTORS_PANEL_SET_PERIOD_ID:
      return {
        ...state,
        periodId: action.id
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/endpointsConnectorsPanel/index.js